import { apiClient } from '@/shared/services/client'
import type { JobStatus, UploadAccepted } from '@/modules/bd-unificada/types/job'

const BASE = '/bd-unificada/uploads'

export async function subirArchivo(archivo: File, fuenteId: string): Promise<UploadAccepted> {
  const formData = new FormData()
  formData.append('archivo', archivo)
  formData.append('fuente_id', fuenteId)
  const response = await apiClient.post<UploadAccepted>(`${BASE}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export async function getJob(jobId: string): Promise<JobStatus> {
  const response = await apiClient.get<JobStatus>(`${BASE}/jobs/${jobId}`)
  return response.data
}
